import { SidePopupLayout } from "src/component/SidePopupLayout"
import { AppSpan, AppText, Button, CustomContainer, FlexRow, GridContainer, Icon, ScreenTitle } from "src/style"
import MovieImg from 'src/assets/img/movie-img2.svg'
import { BsCalendar2EventFill } from "react-icons/bs"
import { IoTime } from "react-icons/io5"
import { MdLocalMovies } from "react-icons/md"
import { AiFillStar } from "react-icons/ai"

export const MovieTicketConfirmation: React.FC<any> = ({back, next, close}) => {

    return (
        <SidePopupLayout close={close}>
            <ScreenTitle textSize="2.2" fontWeight="700">Confirmation</ScreenTitle>
            <CustomContainer topMargin="2">
                <GridContainer>
                    <CustomContainer 
                        width="20" height="26.15" radius="1.16" bottomMargin="2"
                    >
                        <Icon src={MovieImg} minWidth='100' noResize style={{objectFit: 'cover'}}  />
                    </CustomContainer>
                    <AppSpan textSize="2.4" fontWeight="700" color="#111111" fontFamily="Gilmer-Bold">Oceans 8</AppSpan>
                    <FlexRow 
                        gap="2" topMargin="1.7" justifyContent="space-between" width="30.5"
                        className="movie-period-flex" wrap="wrap"
                    >
                        <FlexRow width="auto" sizeUnit="">
                            <BsCalendar2EventFill style={{fontSize: '1.2rem', marginRight: '0.7rem', color: '#434E58'}} />
                            <AppSpan textSize="1.2" color="#78828A">17 Sep 2021</AppSpan>
                        </FlexRow>
                        <FlexRow width="auto" sizeUnit="">
                            <IoTime style={{fontSize: '1.5rem', marginRight: '0.7rem', color: '#434E58'}} />
                            <AppSpan textSize="1.2" color="#78828A">148 Minutes</AppSpan>
                        </FlexRow>
                        <FlexRow width="auto" sizeUnit="">
                            <MdLocalMovies style={{fontSize: '1.5rem', marginRight: '0.7rem', color: '#434E58'}} />
                            <AppSpan textSize="1.2" color="#78828A">Action</AppSpan>
                        </FlexRow>
                    </FlexRow>
                    <FlexRow width="auto" sizeUnit="" gap="0.6" topMargin="1.5">
                        {
                            Array.from(Array(5).keys()).map((item: number) => {
                                let rating = 4
                                let color = rating-1 >= item ? '#FACC15': '#78828A'
                                return (
                                    <AiFillStar style={{color, fontSize: '1.7rem'}} />
                                )
                            })
                        }
                    </FlexRow>
                </GridContainer>
                <CustomContainer
                    minHeight="19.6" borderColor="#EAECF0" padding="2" radius="0.8" topMargin="2"
                >
                    <FlexRow justifyContent="space-between" gap="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Email</AppSpan>
                            <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">example@gmail.com</AppText>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppSpan>Phone Number</AppSpan>
                            <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">07072536172</AppText>
                        </GridContainer>
                    </FlexRow>
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Date</AppSpan>
                            <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">17/09/2023</AppText>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppSpan>Time</AppSpan>
                            <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">6:00PM</AppText>
                        </GridContainer>
                    </FlexRow>
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Tickets</AppSpan>
                            <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">2</AppText>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppSpan>Price</AppSpan>
                            <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">N5000</AppText>
                        </GridContainer>
                    </FlexRow>
                </CustomContainer>
                <FlexRow justifyContent='flex-end' gap="1.5" topMargin='2'>
                        <Button 
                            width='6.7' height='4' bgColor="#ffffff"
                            borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4' color="#344054"
                            onClick={back}
                        >
                            Back
                        </Button>
                        <Button 
                            width='13' height='4' 
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F' titleSize='1.4'
                            onClick={next}
                        >
                            Make Payment
                        </Button>
                    </FlexRow>
            </CustomContainer>
        </SidePopupLayout>
    )
}